import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Badge, Button, Modal, Form } from "react-bootstrap";
import {
  FaCalendarAlt,
  FaBuilding,
  FaDollarSign,
  FaArrowLeft,
  FaFilePdf,
  FaFileWord,
} from "react-icons/fa";
import "./vendorquote.css";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import Table from "../../constants/Table";

const disabledStatuses = ["2", "3", "4", "5", "6", "7", "8", "9", "10", "11","12","13"];

const VendorQuotationDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const rfqState = location.state || {};
  const rfq = rfqState.rfq || rfqState;

  const [showModal, setShowModal] = useState(false);
  const [query, setQuery] = useState("");
  const [file, setFile] = useState(null);
const [supportMessage, setSupportMessage] = useState({
  subject: "",
  content: "",
});
const [errorSupportMessage, setErrorSupportMessage] = useState({
  subject: false,
  content: false,
});
console.log(rfq?.user_id)
const [itemPics, setItemPics] = useState([]);
const [quotationList, setQuotationsList] = useState([]);
const [isRefresh, setIsRefresh] = useState(false);
const [loader, setLoader] = useState(false);
const fileInputRef = useRef(null);
  const handleFileChange = (e) => setFile(e.target.files[0]);
const handleChange = (e, key) => {
  setSupportMessage({ ...supportMessage, [key]: e.target.value });
};
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

// select multiple images (preview)
const selectImage = (e) => {
  const files = Array.from(e.target.files);
  const fileURLs = files.map((file) => URL.createObjectURL(file));
  setItemPics([...itemPics, ...fileURLs]);
  setIsRefresh(!isRefresh);
};

// delete image
const deleteImage = (image) => {
  const updated = itemPics.filter((img) => img !== image);
  setItemPics(updated);
  setIsRefresh(!isRefresh);
};
const mailsendFun = () => {
  setShowModal(false);
  setSupportMessage({ subject: "", content: "" });
  setErrorSupportMessage({ subject: false, content: false });
  setItemPics([]);
  setLoader(false);
  if (fileInputRef.current) fileInputRef.current.value = "";
};

const sendMail = async () => {
  let flag = true;
  let error = { ...errorSupportMessage };

  if (supportMessage.subject.trim().length === 0) {
    error.subject = true;
    flag = false;
  }
  if (supportMessage.content.trim().length === 0) {
    error.content = true;
    flag = false;
  }

  setErrorSupportMessage(error);
  if (!flag) return;

  try {
    setLoader(true);

    const allImages = await Promise.all(
      itemPics.map(async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      })
    );

    const rfqOwnerId = rfq?.user_id

    const payload = {
      rfq_id: rfq?.rfq_id,        
      sender_id: userDetails?.id,  
      receiver_id: rfqOwnerId,     
      subject: supportMessage.subject,
      content: supportMessage.content,
      allImages,
      role: 2 ,
      inquiry_type: "SUPPLIER_QUERY"                    
    };
    const res = await apicall.post(payload, "inquiry");
console.log(res,"res")
    if (res.success) {
      // update request_for_quote_supplier_list status
      await handleUpdate("5", userDetails?.id); // keep your existing logic
      mailsendFun();
      toast.success("Request sent successfully!");
    } else {
      toast.error("Failed to send request.");
    }
  } catch (e) {
    toast.error("Error sending request");
  } finally {
    setLoader(false);
  }
};
const getSupplierSubmittedQuotations = async () => {
  try {
    const res = await apicall.get(
      `getSupplierSubmittedQuotations?company_profile_id=${userDetails.company_profile_id}&rfq_id=${rfq.rfq_id}`
    );

    setQuotationsList(res.data);
  } catch (e) {
    toast.error(e.message.replace("Error:", ""));
  }
};


const handleDownload = async (url) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = url.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error("Download failed", err);
  }
};

const handleUpdate = async (status,sup_id) => {
  try {
    const body = {
      rfq_id: rfq?.rfq_id,
      supplier_id:sup_id, 
      status,
    };
    const res = await apicall.post(body,"updateReqinfo");

    if (res.success) {
      toast.success("Status Updated Successfuly");
      setShowModal(false)
    } else {
      toast.error(res.message || "Submission failed");
    }
  } catch (error) {
    toast.error("Something went wrong while submitting quotation");
  }
};
const itemsArray = rfq?.products?.map((p) => ({
  item: p.item,
  quantity: p.quantity,
  specifications: p.specifications?.length
    ? p.specifications.join(", ")
    : "-",
  unitPrice: p.price,
  total: p.totalItemPrice,
})) || [];

const quotationItems =
  rfq?.supplier_quotation?.items || [];

const downloadFile = (url) => {
  window.open(url, "_blank", "noopener,noreferrer");
};

  useEffect(() => {
    getSupplierSubmittedQuotations();
  }, []);

  if (!rfq || Object.keys(rfq).length === 0) {
    return (
      <div className="container mt-4 text-center">
        <p className="text-danger">No RFQ data found.</p>
        <Button onClick={() => navigate(-1)}>Go Back</Button>
      </div>
    );
  }
const headers = [
  'Item',
  'Quantity',
  'Specifications',
  'Unit Price ($)',
  'Total ($)'
];

const itemsdata = rfq?.products?.map((item) => {
  let formattedParams = "-";

  if (item.params) {
    try {
      const parsedParams =
        typeof item.params === "string"
          ? JSON.parse(item.params)
          : item.params;

      if (parsedParams && typeof parsedParams === "object") {
        formattedParams = Object.entries(parsedParams)
          .map(([key, value]) => `${key} : ${value}`)
          .join(", ");
      }
    } catch (e) {
      formattedParams = item.params; // fallback if JSON breaks
    }
  }

  return [
    item.item,
    item.quantity,
    formattedParams,
    item.price,
    item.totalItemPrice
  ];
});


const quotationHeaders = [
  'RFQ ID',
  'Item',
  'Quantity',
  'Quoted Unit Price ($)',
  'Total ($)'
];

const quotationTableData = quotationList?.map((item) => ([
  item.display_rfq_id,
  item.item,
  item.quantity,
  item.quoted_price,
  (
    Number(item.quoted_price || 0) *
    Number(item.quantity || 0)
  ).toFixed(2)
]));


  return (
    <div className="container-fluid p-4">
      {/* Back */}
      <div className="back-link" onClick={() => navigate(-1)}>
        <FaArrowLeft className="me-2" />
        <span>Back to Dashboard</span>
      </div>

      <div className="row">
        {/* LEFT SECTION */}
        <div className="col-lg-8">
          <Card className="rfq-card mb-4 p-4">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <h3 className="rfq-title">{rfq.title}</h3>
                <div className="d-flex align-items-center mb-2">
                  <span className="text-muted me-2">RFQ ID:</span>
                  <strong>{rfq.display_rfq_id || rfq.rfq_id}</strong>
                  {rfq.status && (
                    <Badge bg="success" className="ms-3 status-badge">
                      {rfq.status}
                    </Badge>
                  )}
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-4">
                <p className="text-muted small mb-1">Company</p>
                <div className="d-flex align-items-center fw-semibold">
                  <FaBuilding className="me-2 text-secondary" />
                  {rfq.company_info?.name || "-"}
                </div>
              </div>
              <div className="col-4">
                <p className="text-muted small mb-1">Deadline</p>
                <div className="d-flex align-items-center fw-semibold">
                  <FaCalendarAlt className="me-2 text-secondary" />
                  {new Date(rfq.responsible_date).toLocaleDateString()}
                </div>
              </div>
              <div className="col-4">
                <p className="text-muted small mb-1">Est. Value</p>
                <div className="d-flex align-items-center fw-semibold text-success">
                  {/* <FaDollarSign className="me-2" /> */}
                  ${Number(rfq.total_price).toLocaleString()}
                </div>
              </div>
            </div>

            {rfq.description && (
              <div className="mt-3">
                <p className="text-muted small mb-1">Description</p>
                <p className="rfq-description">{rfq.description}</p>
              </div>
            )}
          </Card>

          <Card className="rfq-card p-4">
            <h5 className=" mb-3">Items Required</h5>
            <Table
    headers={headers}
    data={itemsdata}
    pagination={false}
  />
          </Card>
          <Card className="rfq-card p-4 mt-4">
  <h5 className=" mb-3">Submitted Quotations</h5>

  <Table
    headers={quotationHeaders}
    data={quotationTableData}
    pagination={false}
  />
</Card>

        </div>

        {/* RIGHT SIDEBAR */}
        <div className="col-lg-4">
          <Card className="rfq-card p-4 mb-4">
            <h5 className=" mb-3">Actions</h5>
            <Button
              variant="danger"
              className="mb-2 w-100"
                disabled={disabledStatuses.includes(String(rfq?.quotation_status)) || rfq.supplier_status === 12}

              onClick={() =>
                navigate(`/vendor_quatation_form/${rfq.rfq_id}`, { state: { rfq } })
              }
            >
              Submit Quotation
            </Button>
            <Button
              variant="outline-secondary"
              className="w-100"
              onClick={() => setShowModal(true)}
              disabled={disabledStatuses.includes(String(rfq?.quotation_status)) || rfq.supplier_status === "12"}

            >
              Request More Information
            </Button>
          </Card>

          <Card className="rfq-card p-4 mb-4">
            <h5 className=" mb-3">Contact Information</h5>
            <p>
                  <strong>Contact Person:</strong> {rfq.user_info?.first_name  || rfq.user_info?.last_name || rfq.user_info?.middle_name || "-"}
            </p>
            <p>
              <strong>Email:</strong> {rfq.user_info?.email || "-"}
            </p>
            <p>
              <strong>Phone:</strong> {rfq.user_info?.phone || "-"}
            </p>
          </Card>

<Card className="rfq-card p-4">
  <h5 className="mb-3">Attachments</h5>

  {rfq.products?.some((p) => p.documents?.length > 0) ? (
    rfq.products.map((product, pIndex) => (
      <div key={`product-${pIndex}`} className="mb-3">
        <h6 className="mb-2">{product.item}</h6>

          {product.documents.map((docUrl, dIndex) => {
            const getFileExtension = (url) => {
              const parts = url.split(".");
              return parts.length > 1 ? parts.pop().toLowerCase() : "pdf";
            };

            const fileName = docUrl.split("/").pop();
            const ext = getFileExtension(docUrl);

            const icon =
              ext === "pdf" ? (
                <FaFilePdf className="me-2 text-danger" />
              ) : (
                <FaFileWord className="me-2 text-primary" />
              );

            const fixedUrl = docUrl.endsWith(".") ? `${docUrl}pdf` : docUrl;

            return (
              <div
                className="d-flex justify-content-between align-items-center mb-2 attachment-item"
                key={`doc-${dIndex}`}
              >
                <div className="d-flex align-items-center">
                  {icon}
                  <span>{fileName}</span>
                </div>

                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => window.open(fixedUrl, "_blank")}
                >
                  ⬇
                </button>
              </div>
            );
          })}
        </div>
      ))
  ) : (
    <p className="text-muted">No attachments available</p>
  )}
</Card>


        </div>
      </div>

       <Modal show={showModal} onHide={() => setShowModal(false)} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title className="fw-semibold">Request more information</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* Subject */}
          <Form.Group className="mb-2">
            <Form.Control
              type="text"
              placeholder="Subject"
              value={supportMessage.subject}
              onChange={(e) => handleChange(e, "subject")}
              isInvalid={errorSupportMessage.subject}
              size="sm"
            />
            {errorSupportMessage.subject && (
              <Form.Text className="text-danger">Enter subject.</Form.Text>
            )}
          </Form.Group>

          {/* Message */}
          <Form.Group className="mb-2">
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter your message..."
              value={supportMessage.content}
              onChange={(e) => handleChange(e, "content")}
              isInvalid={errorSupportMessage.content}
              size="sm"
            />
            {errorSupportMessage.content && (
              <Form.Text className="text-danger">Enter message.</Form.Text>
            )}
          </Form.Group>

          {/* File Upload */}
        <Form.Group className="mb-2">
  <Form.Label className="fw-semibold">Upload document (optional)</Form.Label>

  <div className="border p-2 rounded d-flex align-items-center justify-content-between">
    <label
      htmlFor="fileUpload"
      className="btn btn-outline-secondary m-0"
      style={{ cursor: "pointer", fontSize: "13px", padding: "3px 10px" }}
    >
      Attach Document
    </label>

    <input
      id="fileUpload"
      ref={fileInputRef}
      type="file"
      multiple
      accept="image/*,application/pdf"
      onChange={selectImage}
      style={{ display: "none" }}
    />

    {itemPics.length > 0 && (
      <small className="text-muted ms-2">{itemPics.length} file(s) selected</small>
    )}
  </div>

  {/* Image Previews */}
  <div className="d-flex flex-wrap mt-1" style={{ maxHeight: '50px', overflowY: 'auto' }}>
    {itemPics.map((img, idx) => (
      <div
        key={idx}
        className="position-relative me-1 mb-1"
        style={{ width: 40, height: 40 }}
      >
        <img
          src={img}
          alt="preview"
          className="img-thumbnail"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
        <button
          type="button"
          className="btn btn-sm btn-danger position-absolute top-0 end-0 p-0"
          onClick={() => deleteImage(img)}
          style={{ fontSize: '9px', width: '16px', height: '16px' }}
        >
          ✕
        </button>
      </div>
    ))}
  </div>
</Form.Group>

        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="outline-secondary"
          onClick={() => {
            setSupportMessage({ subject: "", content: "" });
            setItemPics([]);
            if (fileInputRef.current) fileInputRef.current.value = "";
          }}
        >
          {loader ? "..." : "Clear"}
        </Button>
        <Button
          variant="danger"
          onClick={sendMail}
          disabled={loader}
        >
          {loader ? "Sending..." : "Send"}
        </Button>
      </Modal.Footer>
    </Modal>
    </div>
  );
};

export default VendorQuotationDetails;
